<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div>
      <div class="uk-flex uk-flex-between uk-flex-middle">
        <div>
          <h1 class="uk-h4 uk-margin-remove">
            <span data-uk-icon="icon: paint-bucket; ratio:1.2"></span>
            Ansicht
          </h1>
        </div>
        <div>
          <a @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-secondary">
            <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
            Zurück
          </a>
        </div>
      </div>
    </div>
    <div>
      <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
        <div class="uk-card-body">
          <div class="uk-margin">
            <div class="uk-grid uk-grid-small" data-uk-grid>
              <div class="uk-width-1-1">
                <div class="uk-margin">
                  <label>
                    <input class="uk-checkbox" type="checkbox" v-model="config.general.hideImages" />
                    Fahrzeugbilder in der Kundenansicht ausblenden
                  </label>
                </div>
              </div>
              <div class="uk-width-1-1">
                <div class="uk-align-left">
                  <button
                    type="submit"
                    class="uk-button uk-button-primary"
                    @click.prevent="store"
                    :disabled="submitting"
                  >
                    Speichern
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ConfigService from '@/services/config.service'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      loading: true,
      submitting: false,
    }
  },
  computed: {
    ...mapGetters({config: 'merchantConfig'})
  },
  methods: {
    ...mapActions({
      refreshConfig: 'getMerchantConfig'
    }),
    async store() {
      this.submitting = true
      await ConfigService.storeMerchantConfig(this.config)
      this.submitting = false
      this.refreshConfig()
      iziToast.success({
        title: 'OK',
        message: 'Einstellungen gespeichert!',
        timeout: 3000,
        position: 'topCenter'
      })
    }
  }
}
</script>
